module.exports = __webpack_public_path__ + "static/phishing-da510aff9ac1db297a2fb04e69ff26a8.png";